import DocEditorVMBase from "Lib/Fs.SmartClient.Client/DocEditorVMBase";
import { useView, autoinject, inject, Container } from 'aurelia-framework'
import FsUtility from "./FsUtility";

export default class DocSearchVMBase<T extends DocEditorVMBase> extends DocEditorVMBase {
    ItemType: new () => T;
    PageSize: number;
    PageIndex: number;
    EnablePaging: boolean;
    SearchResultCollectionView: T[];
    SelectedItems: T[];
    currentItem: T;
    
    constructor(type: { new(): T; }) {
        super();
        this.ItemType = type;
        this.SelectedItems = [];
        this.SearchResultCollectionView = [];
    }

    get CurrentItem() {
        return this.currentItem;
    }
    set CurrentItem(value: T) {
        this.OnCurrentChanging(this, null);

        var newSelectedEditorVM = value;
        if (newSelectedEditorVM != null)
            newSelectedEditorVM.IsSelectedItem = true;
        this.currentItem = newSelectedEditorVM;

        this.OnCurrentChanged(this, null);
        
    }

    OnCurrentChanging(sender, e) {
        var oldSelectedEditorVM = this.currentItem;
        if (oldSelectedEditorVM != null)
            oldSelectedEditorVM.IsSelectedItem = false;
    };

    OnCurrentChanged(sender, e) {
    };

    SaveOriginalSource(originalSource: any[]) {
        for (var index = 0; index < this.SearchResultCollectionView.length; index++) {
            var item = this.SearchResultCollectionView[index];
            var o = {};
            item.SaveOriginalSource(o);
            originalSource.push(o);
        }
    };

    LoadOriginalSource(originalSource: any, isAdding: boolean) {

        if (isAdding == null)
            isAdding = false;

        this.SearchResultCollectionView = [];
        //this.ClearChildNode();

        if (originalSource == null)
            return;

        var list = [];

        for (var index = 0; index < originalSource.length; index++) {
            var item = originalSource[index];
            var editorVM = new this.ItemType;
            if (isAdding)
                this.InitializeAddingItem(editorVM);
            else
                this.InitializeLoadingItem(editorVM);
            
            editorVM.SetOriginalSource(item, isAdding);

            list.push(editorVM);
            this.AddChildNode(editorVM);
        }

        this.SearchResultCollectionView = list;
    };

    BeginEdit() {
        this.IsEditing = true;
        for (var index = 0; index < this.SearchResultCollectionView.length; index++) {
            var item = this.SearchResultCollectionView[index];
            item.BeginEdit();
        }
    };

    InitializeAddingItem(editorVM: T) {
        editorVM.IsAdding = true;
    };

    InitializeLoadingItem(editorVM: T) {
        editorVM.IsAdding = false;
    };

    CreateNewItem(originalSource: any) {
        var item = new this.ItemType;

        this.AddItem(item);
        this.SelectNewItem(item);
        this.InitializeAddingItem(item);
        if (originalSource != null && originalSource != this)
            item.LoadOriginalSource(originalSource, true);
        this.AddChildNode(item);

        item.BeginEdit();
        item.IsItemEditing = true;

        return item;
    };

    CreateNewItems(originalSource: any) {
        for (var index = 0; index < originalSource.length; index++) {
            var item = originalSource[index];
            var editorVM = Container.instance.get(this.ItemType);
            this.InitializeLoadingItem(editorVM);
            editorVM.LoadOriginalSource(item);

            this.AddChildNode(editorVM);
            this.SearchResultCollectionView.unshift(editorVM);
        }
    };

    BeginEditCommand(vm: T) {
        vm.BeginEdit();
        vm.IsItemEditing = true;
    }

    EndEditCommand(vm: T, cancel: boolean) {
        if (cancel == false) {
            vm.validationController.validate({ object: vm }).then(result => {
                if (result.valid) {
                    vm.EndItemEdit();
                    vm.IsAdding = false;
                }
            });
        } else {
            vm.IsItemEditing = false;
            if (vm.HasOriginalSource)
                vm.LoadOriginalSource(vm.OriginalSource, false);

            if (!vm.HasOriginalSource) {
                this.RemoveItem(vm);
            }
        }
    }

    RemoveCommand(editorVM: T) {
        var searchVM = this;
        var self = this;

        FsUtility.AlertModal("Are you sure to delete ?", 3, 3, function (result) {
            if (result == true) {
                searchVM.RemoveItem(editorVM);
                searchVM.RemoveChildNode(editorVM);
            }
        });

    }

    RemoveItem(item: T) {
        this.CurrentItem = null;
        for (var i = 0; i < this.SearchResultCollectionView.length; i++) {
            if (this.SearchResultCollectionView[i] === item) {
                this.SearchResultCollectionView.splice(i, 1);
            }
        }
    };

    AddItem(item: T) {
        this.SearchResultCollectionView.push(item);
    };

    SelectNewItem(editorVM: T) {
        this.CurrentItem = editorVM;
    }

    SelectChanged(editorVM: T, isChecked: boolean) {
        if (isChecked) {
            this.SelectedItems.push(editorVM);
        } else {
            for (var i = 0; i < this.SelectedItems.length; i++) {
                if (this.SelectedItems[i] === editorVM) {
                    this.SelectedItems.splice(i, 1);
                }
            }
        }
    }
    Validate() {
        super.ValidateData();

        var valid = super.Validate();
        for (var i = 0; i < this.SearchResultCollectionView.length; i++) {
            var editorVM = this.SearchResultCollectionView[i];
            editorVM.ValidateData()
            valid = valid && editorVM.Validate();
        }

        return valid;
    }
}
